import { BaseCaption, Caption } from '@supermeme-ai/types'
import { generalApiClient } from '@/utils/clients/general-api'

export const saveMemeResult = async (
  accessToken: string,
  resultId: number,
  captions: Caption[],
  header?: BaseCaption,
  footer?: BaseCaption
) => {
  generalApiClient.setAuthToken(accessToken)

  await generalApiClient.updateResult(resultId, captions, header, footer)
}
